import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@usacow/ds';
import type { DrillKind } from '@usacow/drills';
import { api } from '../lib/api';
import { DrillSession } from '../components/DrillSession';

export function Workout() {
  const navigate = useNavigate();
  const [slots, setSlots] = useState<DrillKind[] | null>(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    api
      .getWorkout()
      .then((w) => setSlots(w.slots as DrillKind[]))
      .catch(() => setSlots([]));
  }, []);

  if (!slots) return <div className="route-loading">Loading…</div>;

  return (
    <div className="scr scr--narrow">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">daily workout · ~15 min · {slots.length} slots</div>
          <h1 className="scr-h">Today&apos;s session</h1>
        </div>
      </div>
      {!started ? (
        <>
          <p className="diag-lead">
            A short adaptive mix of recognition, execution, and proof — not just solving full
            problems. Each slot updates your mastery and review schedule.
          </p>
          <Button variant="primary" size="lg" onClick={() => setStarted(true)}>
            Start session
          </Button>
        </>
      ) : (
        <DrillSession slots={slots} onDone={() => navigate('/app')} />
      )}
    </div>
  );
}
